import React, { useEffect, useState } from "react";
import { Users, Server, AlertTriangle, IndianRupee, Receipt, Activity, PauseCircle } from "lucide-react";
import { adminGetDashboard } from "../../lib/api";

function Stat({ icon: Icon, label, value, tone = "default" }) {
  const tones = {
    default: "bg-white border-[#11151C]/10",
    accent: "bg-[#FFFBF6] border-[#FF6B3D]/30",
    warn: "bg-yellow-50 border-yellow-200",
    danger: "bg-red-50 border-red-200",
    success: "bg-green-50 border-green-200",
  };
  return (
    <div className={`rounded-2xl border p-5 ${tones[tone]}`}>
      <div className="flex items-center justify-between">
        <span className="text-xs font-bold text-[#11151C]/60 uppercase tracking-wider">{label}</span>
        <Icon className="w-5 h-5 text-[#FF6B3D]" />
      </div>
      <div className="mt-2 lm-font font-extrabold text-3xl text-[#11151C]">{value}</div>
    </div>
  );
}

export default function DashboardPanel() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminGetDashboard().then(setData).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-[#11151C]/60">Loading dashboard...</div>;

  return (
    <div>
      <h2 className="lm-font font-extrabold text-[#11151C] text-2xl">Dashboard</h2>
      <p className="text-[#11151C]/60 text-sm mt-1">Overview of your hosting reseller business.</p>

      <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat icon={Users} label="Total customers" value={data?.customers ?? 0} tone="accent" />
        <Stat icon={Server} label="Hosting accounts" value={data?.hosting_total ?? 0} />
        <Stat icon={Activity} label="Active" value={data?.hosting_active ?? 0} tone="success" />
        <Stat icon={PauseCircle} label="Suspended" value={data?.hosting_suspended ?? 0} tone="warn" />
        <Stat icon={AlertTriangle} label="Expiring in 30d" value={data?.expiring_30d ?? 0} tone="warn" />
        <Stat icon={Receipt} label="Unpaid invoices" value={data?.unpaid_invoices ?? 0} tone="danger" />
        <Stat icon={IndianRupee} label="Revenue (paid)" value={`\u20b9${(data?.revenue_inr || 0).toLocaleString("en-IN")}`} tone="accent" />
      </div>
    </div>
  );
}
